import { AxiosPromise } from 'axios';
import qs from 'qs';

import { BaseService } from './BaseServices';
import { IOrderType } from '../types/OrderType';
import { IFilterType } from '../types/ProfileTypes';

export default class BasePaginateService extends BaseService {
  constructor(url: any) {
    super(url);
  }

  public getPaginateAll(
    page: number = 1,
    size: number = 10,
    orders: IOrderType[],
    filters: IFilterType[],
    search: string,
    url: string = '',
    other?: any
  ): AxiosPromise<any[]> {
    const params = {
      search,
      filters,
      pageable: {
        page,
        size,
        orders
      }
    };
    return this.httpAxios
      .get(url, {
        params: { data: JSON.stringify(params), ...other },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        }
      })
      .then((response: any) => response)
      .catch(err => {
        throw err;
      });
  }
}
